export default __webpack_public_path__ + "static/media/pound.f0bd8cbe.svg";